'use strict';

var React = require('react');
var amplitude = require('./amplitude.js');

var useHCWebExperiment = function useHCWebExperiment(_ref) {
  var experimentName = _ref.experimentName,
      experimentVariantName = _ref.experimentVariantName;
  if (!experimentVariantName) return {
    isExperimentActive: false
  };
  var variant = React.useMemo(function () {
    var amplitudeVaultStorageKey = amplitude.getAmplitudeVaultStorageKey();

    try {
      var experiments = JSON.parse(localStorage.getItem(amplitudeVaultStorageKey)) || {};
      return experiments[experimentName];
    } catch (err) {
      console.error('Error accessing experiments in local storage', err);
    }
  }, [experimentName]);
  return {
    isExperimentActive: (variant === null || variant === void 0 ? void 0 : variant.value) === experimentVariantName
  };
};

module.exports = useHCWebExperiment;
